// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-simple-mfa {
  background-color: #fff; /* Light background for modal */
  border-radius: 10px;
  color: #000; /* Black text color for contrast */
}

.modal-simple-mfa  h2, .modal-simple-mfa  h3 {
  color: #333; /* Darker gray for headers */
  font-size: 20px;
  font-weight: 600;
}

.modal-simple-mfa  p.info-text {
  color: #666; /* Medium gray for informational text */
  margin-bottom: 15px;
}

.modal-simple-mfa  .step {
  display: flex;
  align-items: flex-start;
  margin-bottom: 20px;
}

.modal-simple-mfa .step-number {
  background-color: #007bff; /* Use blue for step numbers */
  color: white;
  border-radius: 50%;
  padding: 10px;
  display: grid;
  font-size: 16px;
  font-weight: 600;
  margin-right: 15px;
  width: 30px;
  height: 30px;
  place-content: center;
}

.modal-simple-mfa .step-content {
  max-width: 90%;
}

.modal-simple-mfa .qr-box {
  margin: 15px 0;
  padding: 10px;
  background-color: #f1f3f5; /* Light background for QR box */
  border: 2px dashed #999; /* Lighter border */
  text-align: center;
  border-radius: 8px;
}

.modal-simple-mfa .otp-input-width {
  width: 50px; /* Uniform width */
  height: 50px;
  text-align: center;
  font-size: 20px;
  margin-right: 10px;
  margin-bottom: 10px;
  border: 2px solid #ccc; /* Lighter border for OTP inputs */
}

.modal-simple-mfa .btn-close {
  color: #000; /* Black close button */
  font-size: 18px;
  position: absolute;
  right: 10px;
  top: 10px;
}

.modal-simple-mfa  button {
  margin-top: 20px;
}

.modal-simple-mfa  button.rounded-pill:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/components/Layout/MFASetup.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB,EAAE,+BAA+B;EACvD,mBAAmB;EACnB,WAAW,EAAE,kCAAkC;AACjD;;AAEA;EACE,WAAW,EAAE,4BAA4B;EACzC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW,EAAE,uCAAuC;EACpD,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB,EAAE,8BAA8B;EACzD,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,yBAAyB,EAAE,gCAAgC;EAC3D,uBAAuB,EAAE,mBAAmB;EAC5C,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW,EAAE,kBAAkB;EAC/B,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB,EAAE,kCAAkC;AAC5D;;AAEA;EACE,WAAW,EAAE,uBAAuB;EACpC,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB","sourcesContent":[".modal-simple-mfa {\n  background-color: #fff; /* Light background for modal */\n  border-radius: 10px;\n  color: #000; /* Black text color for contrast */\n}\n\n.modal-simple-mfa  h2, .modal-simple-mfa  h3 {\n  color: #333; /* Darker gray for headers */\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.modal-simple-mfa  p.info-text {\n  color: #666; /* Medium gray for informational text */\n  margin-bottom: 15px;\n}\n\n.modal-simple-mfa  .step {\n  display: flex;\n  align-items: flex-start;\n  margin-bottom: 20px;\n}\n\n.modal-simple-mfa .step-number {\n  background-color: #007bff; /* Use blue for step numbers */\n  color: white;\n  border-radius: 50%;\n  padding: 10px;\n  display: grid;\n  font-size: 16px;\n  font-weight: 600;\n  margin-right: 15px;\n  width: 30px;\n  height: 30px;\n  place-content: center;\n}\n\n.modal-simple-mfa .step-content {\n  max-width: 90%;\n}\n\n.modal-simple-mfa .qr-box {\n  margin: 15px 0;\n  padding: 10px;\n  background-color: #f1f3f5; /* Light background for QR box */\n  border: 2px dashed #999; /* Lighter border */\n  text-align: center;\n  border-radius: 8px;\n}\n\n.modal-simple-mfa .otp-input-width {\n  width: 50px; /* Uniform width */\n  height: 50px;\n  text-align: center;\n  font-size: 20px;\n  margin-right: 10px;\n  margin-bottom: 10px;\n  border: 2px solid #ccc; /* Lighter border for OTP inputs */\n}\n\n.modal-simple-mfa .btn-close {\n  color: #000; /* Black close button */\n  font-size: 18px;\n  position: absolute;\n  right: 10px;\n  top: 10px;\n}\n\n.modal-simple-mfa  button {\n  margin-top: 20px;\n}\n\n.modal-simple-mfa  button.rounded-pill:disabled {\n  background-color: #ccc;\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
